'use strict';

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tlChoiceButton', function ($compile, $translate, $interpolate) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '' + '<span class="tl-choice-button" ng-transclude>' + '</span>',
    scope: {
      model: '='
    },
    controller: function controller($scope) {
      $scope.clicked = function (event) {
        var nullOption = angular.element(event.currentTarget).attr('null-option');
        if (nullOption) {
          $scope.model = null;
        } else {
          $scope.model = angular.element(event.currentTarget).attr('value');
        }
      };
    },
    link: function postLink(scope, element) {
      var items = element[0].children;
      var _iterator = _createForOfIteratorHelper(items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var value = angular.element(item).attr('value');
          var nullOption = angular.element(item).attr('null-option');
          console.log('nullOption', nullOption);
          if (nullOption === 'true') {
            value = 'null';
          } else {
            value = '\'' + value + '\'';
          }
          angular.element(item).attr('ng-click', 'clicked($event)');
          angular.element(item).attr('ng-class', '{\'tl-active-choice-item\':model===' + value + '}');
          item.classList.add("tl-choice-item");
          $compile(item)(scope);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/buttons/tl-choice-button.js
// module id = 2924
// module chunks = 13